import { render, staticRenderFns } from "./channelInfo.vue?vue&type=template&id=2e71a5e3&scoped=true"
import script from "./channelInfo.vue?vue&type=script&lang=js"
export * from "./channelInfo.vue?vue&type=script&lang=js"
import style0 from "./channelInfo.vue?vue&type=style&index=0&id=2e71a5e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e71a5e3",
  null
  
)

export default component.exports